import React, { useEffect } from "react";

import ArchivePageInfo from "./ArchivePageInfo";

import {
  BrowserRouter,
  Switch,
  Route,
  RouteComponentProps,
  useParams,
  useHistory,
} from "react-router-dom";
import ArchiveMaterial from "./ArchiveMaterial";
import MetaSeo from "../../MetaSeo";

interface ArchivePageComponentProps {
  //   history: any;
  //   match: any;
  //   location: any;
  rowData: any;
  match: any;
}
function ArchivePageComponent({ rowData, match }: ArchivePageComponentProps) {
  console.log(rowData);
  return (
    <React.Fragment>
      <MetaSeo
        data={{
          title: rowData.title,
          canonical: `http://laborbusan.or.kr/archive/${match.params.sub_page_slug}`,
        }}
      />
      <ArchivePageInfo rowData={rowData} />
      <ArchiveMaterial rowData={rowData} />
    </React.Fragment>
  );
}
export default ArchivePageComponent;
